module.exports = __webpack_public_path__ + "img/Diaper change.2a4c10d7.png";